// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2-KZI","content":"ManualTimeModal_content__Q4OBP"};